import { useEffect, useState } from "react"

const getWindowHeight = () => {
  return window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
}

export const useSidebarTopOffset = (hasMounted: boolean, isMobile: boolean) => {
  const [sidebarOffsetTop, setSidebarOffsetTop] = useState(0)
  useEffect(() => {
    const sidebar = document.getElementById("pdp-sidebar")

    if (!sidebar || !hasMounted || isMobile) return

    // eslint-disable-next-line compat/compat
    const resizeObserver = new ResizeObserver(() => {
      const windowHeight = getWindowHeight()

      if (windowHeight < sidebar.getBoundingClientRect().height) {
        setSidebarOffsetTop(
          windowHeight - sidebar.getBoundingClientRect().height
        )
      } else {
        setSidebarOffsetTop(0)
      }
    })

    const handleResize = () => {
      resizeObserver.disconnect()
      resizeObserver.observe(sidebar)
    }

    window.addEventListener("resize", handleResize)

    resizeObserver.observe(sidebar)

    return () => {
      window.removeEventListener("resize", handleResize)
      resizeObserver.disconnect()
    }
  }, [hasMounted, isMobile])

  return { sidebarOffsetTop }
}
